import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,HttpClientJsonpModule } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AppTokenHandler } from '../common/app-token-handler';

@Injectable()
export class DataService {
    private apiUrl: string;
    private httpDataServiceOptions: any;
    private httpHeaderFileDownload: any;
    private httpHeaderFileUpload: any;

    constructor(private appToken: AppTokenHandler, private http: HttpClient) {
        
        this.apiUrl = environment.serviceBaseUrl;
        this.httpHeaderFileDownload = {
            headers: new HttpHeaders({
                access_token: this.appToken.getSessionToken()
            }),
            responseType: 'blob',
            withCredentials: true
        };
        this.httpHeaderFileUpload = {
            headers: new HttpHeaders({
                access_token: this.appToken.getSessionToken()
            }),
            withCredentials: true
        };
    }

    // Login(Email: string = '') {
    //     debugger;
    //     const body: any = null;
    //     let params = new HttpParams();
    //     params = params.append('ApplicationCode', environment.appcode);
    //     if (Email.length > 0) {
    //         params = params.append('Email', Email);
    //     }
    //     const httpLoginPostOptions = {
    //         withCredentials: true,
    //         params: params
    //     };
    //     return this.http.post(environment.tokenPath, null, httpLoginPostOptions).pipe(catchError(this.handleError));
    // }

    Login(Email: string = '', AzureToken: string = '') {
        const body: any = null;
        const httpDataServiceOptions = {
            headers: new HttpHeaders({ AzureAccessToken: AzureToken }), withCredentials: true
        }
        return this.http.get(environment.tokenPath, httpDataServiceOptions).pipe(catchError(this.handleError));
    }

    GetData(_url: string) {
        _url = environment.serviceBaseUrl + _url;
        return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    GetDataById(_url: string, _id: string) {
        _url = environment.serviceBaseUrl + _url + '/' + _id;
        return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    PostData(_url: string, _postdata: any) {
        _url = environment.serviceBaseUrl + _url;
        return this.http.post(_url, _postdata, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    private handleError(error: Response) {
        return throwError(error);
    }
    postfile(url, formData) {
        return this.http.post<any>(this.apiUrl + url, formData, this.httpHeaderFileUpload)
            .pipe(
            );
    }
    ContainsSpecialCharacters(searchString: string) {
        let IsValidString = true;
        if (searchString.length > 0) {
            const regex = /^[A-Za-z0-9 ]+$/;
            IsValidString = regex.test(searchString);
        }
        return (IsValidString === true ? false : true);
    }
    LogoutUser(_url: string) {
        _url = environment.serviceBaseUrl + _url;
        return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    DownloadFile(url) {
        return this.http.get(this.apiUrl + url, this.httpHeaderFileDownload)
            .pipe(
            );
    }
    PostDownload(Url: string, param: any, ) {
        return this.http.post(this.apiUrl + Url, param, this.httpHeaderFileDownload)
            .pipe();
    }
    DownloadFileWithPost(url, formData) {
        return this.http.post(this.apiUrl + url, formData, this.httpHeaderFileDownload)
            .pipe(
            );
    }
    LogPageAnalytics(url) {
        //alert('dataservice');
        return this.http.jsonp(url, "JSONP_CALLBACK")
            .pipe();
    }

    
}

@Injectable()
export class UIBlockingStatus {
    private IsBlocked: BehaviorSubject<boolean>;
    constructor() {
        this.IsBlocked = new BehaviorSubject(false);
    }

    setStatus(_IsBlocked: boolean) {
        this.IsBlocked.next(_IsBlocked);
    }

    getStatus(): Observable<boolean> {
        return this.IsBlocked.asObservable();
    }

}
